import cx from 'clsx';
import Link from 'next/link';

import { CoverLinkList } from '@/components/cover-link-list';
import { joinSgcmSite } from '@/utils/url/join/public';

import { SimilarUsedCarItem } from './item';
import styles from './styles.module.scss';
import type { Component } from './types';

export const SimilarUsedCarItems: Component = ({
  list,
}) => (
  <CoverLinkList
    contentContainerClassName={cx(
      styles.containerCoverLinkList,
      styles.isBehind,
    )}>
    {
      list.map(item => (
        <Link
          key={item.id}
          href={`${joinSgcmSite(`/used_cars/info.php?ID=${item.id}&DL=${item.dealerId}`)}`}>
          <SimilarUsedCarItem
            key={`car-${item.id}`}
            car={item} />
        </Link>
      ))
    }
  </CoverLinkList>
);
